import React, { useState, useCallback, memo } from "react";
import { BsFillArrowRightCircleFill, BsFillArrowLeftCircleFill} from "react-icons/bs";

const Slider = memo(({ slides }) => {
  const [current, setCurrent] = useState(0);

  const previousSlide = useCallback(() => {
    setCurrent(prev => prev === 0 ? slides.length - 1 : prev - 1);
  }, [slides.length]);

  const nextSlide = useCallback(() => {
    setCurrent(prev => prev === slides.length - 1 ? 0 : prev + 1);
  }, [slides.length]);

  const goToSlide = useCallback((index) => {
    setCurrent(index);
  }, []);

  return (
    <div className="overflow-hidden relative">
      <div
        className={`flex transition ease-out duration-40`}
        style={{
          transform: `translateX(-${current * 100}%)`,
        }}
      >
        {slides.map((s, index) => (
          <img 
            key={`slide-${index}`} 
            src={s} 
            alt={`slide-${index}`} 
            className="w-full" 
            loading={index === 0 ? "eager" : "lazy"}
          />
        ))}
      </div>

      <div className="absolute top-0 h-full w-full justify-between items-center flex text-gray-400 px-4 text-3xl">
        <button onClick={previousSlide} aria-label="Previous slide">
          <BsFillArrowLeftCircleFill />
        </button>
        <button onClick={nextSlide} aria-label="Next slide">
          <BsFillArrowRightCircleFill />
        </button>
      </div>

      <div className="absolute bottom-0 py-4 flex justify-center gap-3 w-full">
        {slides.map((s, i) => {
          return (
            <div
              onClick={() => goToSlide(i)}
              key={`circle-${i}`}
              className={`rounded-full w-4 h-4 cursor-pointer  ${
                i === current ? "bg-white" : "bg-gray-500"
              }`}
              aria-label={`Go to slide ${i + 1}`}
            ></div>
          );
        })}
      </div>
    </div>
  );
});

Slider.displayName = 'Slider';

export default Slider;
